/* @flow */

import { combineReducers } from 'redux';
import { Stack, Map } from 'immutable';
import {
  UPLOAD_FILE,
  UPLOADING_FILE,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAILURE,
  CANCEL_PENDING,
} from '../actions/uploads';
import { isRunning } from './upload';

const pending = (state = Stack(), action) => {
  switch (action.type) {
    case UPLOAD_FILE:
      return state.unshift(action.upload);
    case UPLOADING_FILE:
      return state.shift();
    case CANCEL_PENDING:
      return state.clear();
    default:
      return state;
  }
};

const running = (state = Map(), action) => {
  switch (action.type) {
    case UPLOADING_FILE:
      return state.set(action.upload.token, action.upload);
    case UPLOAD_FILE_FAILURE:
      return state.update(action.upload.token, upload => ({
        ...upload,
        state: 'error',
        error: action.error,
      }));
    case UPLOAD_FILE_SUCCESS:
      return state.delete(action.upload.token);
    default:
      return state;
  }
};

export default combineReducers({
  pending,
  running,
});

export const getPendingUploads = state => state.uploads.pending;
export const getRunningUploads = state => state.uploads.running.toList();
export const getRunningCount = state => state.uploads.running.count(isRunning);



// WEBPACK FOOTER //
// ./src/modules/bucket/reducers/uploads.js